export default function ({$axios, app}) {
  let refreshPromise = null

  $axios.onError((error) => {
    error.details = error.response?.data
  })

  $axios.interceptors.request.use((config) => {
    if (app?.i18n?.locale) {
      $axios.setHeader('Accept-Language', app?.i18n?.locale)
    }
    return config;
  });

  $axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config
      if (
        error.response?.status === 401 &&
        !originalRequest._retry &&
        app.$auth?.loggedIn
      ) {
        originalRequest._retry = true

        if (!refreshPromise) {
          refreshPromise = app.$auth.refreshTokens()
            .catch(() => {
              app.$auth.logout()
              return Promise.reject(error)
            })
            .finally(() => {
              refreshPromise = null
            })
        }

        await refreshPromise
        originalRequest.headers.Authorization = $axios.defaults.headers.common.Authorization
        return $axios(originalRequest)
      }

      return Promise.reject(error)
    }
  )
}
